import { Injectable } from '@angular/core';
import { ApiService } from '@app/api/api.service';
import { CountryDto } from '@app/models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CountryApi extends ApiService {
  private readonly URL_PREFIX = '/country';

  public getCountries$(): Observable<CountryDto[]> {
    return this.get(`${this.URL_PREFIX}/list`, true);
  }
}
